// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"YZ-z","sponsoredTooltipWrapper":"ZZ-z","sponsoredTooltip":"_Z-z","newCard":"a0-z"};